/******************************************************************************
 *** MbrasWhdwlApply ** 탈퇴 신청서
 *******************************************************************************/
import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import Button from "@/js/common/ui/Button";
import DatePickerBox from "@/js/common/ui/input/DatePickerBox";
import SelectBox from "@/js/common/ui/input/SelectBox";
import TextBox from "@/js/common/ui/input/TextBox";
import Util from "@/js/common/Util";
import React from "react";

import MemberFile from "../FileBox/MemberFile";
import AtrzLineBox from "../../bgtovrl/dialog/AtrzLineBox";

const MbrasWhdwlApply = (props: any) => {
    const {mbrasId, mbrasAtrzDocId, setModalOpen, setCallTime,} = props;

    const [mbrasNm           , setMbrasNm           ] = React.useState("");     // 성명
    const [telno             , setTelno             ] = React.useState("");     // 전화번호
    const [brdtDate          , setBrdtDate          ] = React.useState("");     // 생년월일
    const [gndrCd            , setGndrCd            ] = React.useState("");     // 성별
    const [lbrShpSeCd        , setLbrShpSeCd        ] = React.useState("");     // 근로형태
    const [ocptTypeCd        , setOcptTypeCd        ] = React.useState("");     // 직종
    const [ogdpOrgCd         , setOgdpOrgCd         ] = React.useState("");     // 소속조직
    const [wtjrNm            , setWtjrNm            ] = React.useState("");     // 관내
    const [addr              , setAddr              ] = React.useState("");     // 주소
    const [memo              , setMemo              ] = React.useState("");     // 메모
    const [frstJncmpYmd      , setFrstJncmpYmd      ] = React.useState("");     // 최초입사일자
    const [joinYmd           , setJoinYmd           ] = React.useState("");     // 가입일자
    const [mbrasJoinSttsCd   , setMbrasJoinSttsCd   ] = React.useState("");     // 현재 조합원 상태
    const [whdwlDt           , setWhdwlDt           ] = React.useState("");     // 탈퇴 신청일자
    const [whdwlRsnCn        , setWhdwlRsnCn        ] = React.useState("");     // 탈퇴 사유
    const [atrzSttsCd        , setAtrzSttsCd        ] = React.useState("01");   // 결재상태
    const [wthdStatusCd      , setWthdStatusCd      ] = React.useState("");   // 원천징수 상태코드
    const [atrzOpnnCn        , setAtrzOpnnCn        ] = React.useState("");     // 반려사유
    const [listLine          , setListLine          ] = React.useState<any[]>([]); // 결재 라인 정보
    const [openLine          , setOpenLine          ] = React.useState<boolean>(false); // 기본 펼침/접힘
    const [whdwlFile         , setWhdwlFile         ] = React.useState<File>(); // 탈퇴 신청서
    const [whdwlFileNm       , setWhdwlFileNm       ] = React.useState("");     // 탈퇴 신청서명
    const [whdwlAtchFileId   , setWhdwlAtchFileId   ] = React.useState("");     // 탈퇴 신청서 첨부파일 ID
    const [wthdFile          , setWthdFile          ] = React.useState<File>(); // 원천징수 파일
    const [wthdFileNm        , setWthdFileNm        ] = React.useState("");     // 원천징수 파일명
    const [wthdAtchFileId    , setWthdAtchFileId    ] = React.useState("");     // 원천징수 첨부파일 ID
    const [etcFile           , setEtcFile           ] = React.useState<File>(); // 기타 첨부파일
    const [etcFileNm         , setEtcFileNm         ] = React.useState("");     // 기타 첨부파일명
    const [etcAtchFileId     , setEtcAtchFileId     ] = React.useState("");     // 기타 첨부파일 ID

    // 탈퇴 신청 상세조회
    React.useEffect(() => {
        if (Util.isEmpty(mbrasId)) return;

        AppContext.showSpinner();

        Axios.dataAccess({
            url        : "system/mbras/whdwl/select-mbras-whdwl-dtl.do",
            methodType : "post",
            paramType  : "json",
            paramData  : {
                mbrasId       : mbrasId,
                mbrasAtrzDocId: mbrasAtrzDocId,
            },
            onSuccessFn: (res: any) => {
                if (Util.isNotEmpty(res.result.mbras)) {
                    const mbras = res.result.mbras;

                    setMbrasNm        (mbras.mbrasNm        ); // 성명
                    setTelno          (mbras.telno          ); // 전화번호
                    setBrdtDate       (mbras.brdtDate       ); // 생년월일
                    setGndrCd         (mbras.gndrCd         ); // 성별
                    setLbrShpSeCd     (mbras.lbrShpSeCd     ); // 근로형태
                    setOcptTypeCd     (mbras.ocptTypeCd     ); // 직종
                    setOgdpOrgCd      (mbras.ogdpOrgCd      ); // 소속조직
                    setWtjrNm         (mbras.wtjrNm         ); // 관내
                    setAddr           (mbras.addr           ); // 주소
                    setMemo           (mbras.memo           ); // 메모
                    setFrstJncmpYmd   (mbras.frstJncmpYmd   ); // 최초입사일자
                    setJoinYmd        (mbras.joinYmd        ); // 가입일자
                    setMbrasJoinSttsCd(mbras.mbrasJoinSttsCd); // 현재 조합원 상태
                    setWthdStatusCd   (mbras.wthdStatusCd   ); // 현재 원천징수 가입상태
                }

                if (Util.isNotEmpty(res.result.item)) {
                    const item = res.result.item;

                    setWhdwlDt    (item.whdwlDt    ); // 탈퇴 신청일자
                    setWhdwlRsnCn (item.whdwlRsnCn ); // 탈퇴 사유
                    setAtrzSttsCd (item.atrzSttsCd ); // 결재상태
                    setAtrzOpnnCn (item.atrzOpnnCn ); // 반려사유
                    setListLine(item.listLine);
                }

                if (Util.isNotEmpty(res.result.listFile)) {
                    const listFile = res.result.listFile;
                    const whdwlFileInfo = listFile.find((item: any) => item.mbrasFileSeCd === "01");
                    const wthdFileInfo  = listFile.find((item: any) => item.mbrasFileSeCd === "02");
                    const etcFileInfo   = listFile.find((item: any) => item.mbrasFileSeCd === "03");

                    if (Util.isNotEmpty(whdwlFileInfo)) {
                        setWhdwlAtchFileId(whdwlFileInfo.mbrasAtchFileId);
                        setWhdwlFileNm    (whdwlFileInfo.fileNm);
                    }

                    if (Util.isNotEmpty(wthdFileInfo)) {
                        setWthdAtchFileId(wthdFileInfo.mbrasAtchFileId);
                        setWthdFileNm    (wthdFileInfo.fileNm);
                    }

                    if (Util.isNotEmpty(etcFileInfo)) {
                        setEtcAtchFileId(etcFileInfo.mbrasAtchFileId);
                        setEtcFileNm    (etcFileInfo.fileNm);
                    }
                }

                AppContext.hideSpinner();
            },
        });
    }, [mbrasId, mbrasAtrzDocId]);

    const getParamData = (saveAtrzSttsCd: string) => {
        return {
            mbrasId        : mbrasId,
            mbrasAtrzDocId : mbrasAtrzDocId,
            mbrasNm        : mbrasNm,
            brdtDate       : brdtDate,
            gndrCd         : gndrCd,
            telno          : telno,
            lbrShpSeCd     : lbrShpSeCd,
            ocptTypeCd     : ocptTypeCd,
            ogdpOrgCd      : ogdpOrgCd,
            wtjrNm         : wtjrNm,
            addr           : addr,
            memo           : memo,
            frstJncmpYmd   : frstJncmpYmd,
            joinYmd        : joinYmd,
            whdwlDt        : whdwlDt,
            applyDt        : whdwlDt, // 신청일자
            whdwlRsnCn     : whdwlRsnCn,
            atrzSttsCd     : saveAtrzSttsCd,
            mbrasJoinSttsCd: mbrasJoinSttsCd, // 조합원가입상태코드
            wthdStatusCd   : wthdStatusCd,    // 현재 원천징수 가입코드
            whdwlFile      : whdwlFile,
            wthdFile       : wthdFile,
            etcFile        : etcFile,
            callType       : "MEMBER",
            wthdSeCd       : "03",
        };
    };

    const handleSave = (saveAtrzSttsCd: string) => {
        if (Util.isEmpty(mbrasId)) { AppContext.openAlert({ title: "확인", msg: "대상 조합원이 없습니다.", icon: "warning" }); return; }
        if (saveAtrzSttsCd === "02" && Util.isEmpty(whdwlDt)) { AppContext.openAlert({ title: "탈퇴신청일자 확인", msg: "탈퇴신청일자를 입력해주세요.", icon: "warning" }); return; }
        if (saveAtrzSttsCd === "02" && Util.isEmpty(whdwlRsnCn)) { AppContext.openAlert({ title: "탈퇴사유 확인", msg: "탈퇴사유를 입력해주세요.", icon: "warning" }); return; }
        if (saveAtrzSttsCd === "02" && !whdwlFile && Util.isEmpty(whdwlAtchFileId)) { AppContext.openAlert({ title: "첨부파일 확인", msg: "탈퇴 신청서를 첨부해주세요.", icon: "warning" }); return; }
        if (saveAtrzSttsCd === "02" && !wthdFile && Util.isEmpty(wthdAtchFileId) && wthdStatusCd === "W01") { AppContext.openAlert({ title: "첨부파일 확인", msg: "원천징수 파일을 첨부해주세요.", icon: "warning" }); return; }

        const saveTitle = saveAtrzSttsCd === "01" ? "임시저장" : "작성완료";
        const saveMsg = saveAtrzSttsCd === "01" ? "임시 저장하시겠습니까?" : "작성완료 처리하시겠습니까?";

        AppContext.openAlert({
            title        : saveTitle,
            msg          : saveMsg,
            confirmText  : saveTitle,
            handleConfirm: () => {
                AppContext.showSpinner();
                Axios.dataAccess({
                    url         : "system/mbras/whdwl/save-mbras-whdwl.do",
                    methodType  : "post",
                    isMultipart : true,
                    paramData   : getParamData(saveAtrzSttsCd),
                    onSuccessFn : () => {
                        AppContext.hideSpinner();
                        setAtrzSttsCd(saveAtrzSttsCd);
                        AppContext.openAlert({
                            title: "저장 완료",
                            msg  : saveAtrzSttsCd === "01" ? "임시저장 처리되었습니다." : "작성완료 처리되었습니다.",
                            icon : "success",
                        });
                        setCallTime(Date.now());
                        setModalOpen(false);
                    },
                });
            },
        });
    };

    const handleDelete = () => {
        if (Util.isEmpty(mbrasAtrzDocId)) return;

        AppContext.openAlert({
            title        : "삭제",
            msg          : "정말 삭제하시겠습니까?",
            confirmText  : "삭제하기",
            handleConfirm: () => {
                AppContext.showSpinner();
                Axios.dataAccess({
                    url        : "system/mbras/whdwl/delete-mbras-whdwl.do",
                    methodType : "post",
                    paramType  : "json",
                    paramData  : { mbrasAtrzDocId: mbrasAtrzDocId },
                    onSuccessFn: () => {
                        AppContext.hideSpinner();
                        AppContext.openAlert({ title: "삭제 완료", msg: "삭제가 완료되었습니다.", icon: "success" });
                        setCallTime(Date.now());
                        setModalOpen(false);
                    },
                });
            },
        });
    };

    return (
        <div className="w100p dpFlx">
            <div className="w540">
                {atrzSttsCd === "05" && (
                    <div className="ml10 mr10">
                        <AtrzLineBox
                            listLine={listLine}
                            open={openLine}
                            onToggle={() => setOpenLine((v) => !v)}
                            showOrgInfo={true}
                        />
                    </div>
                )}

                {/* 조합원 정보 */}
                <div className="m10">
                    <div className="fm-b fs16 fc007bff ls1 fw700 mb10">조합원 정보</div>

                    <div className="p14 bd1 bdcDDDDDD bdrd10 bgcFAFAFA bsBdb">
                        <div className="dpFlx flxNowrap jcSb">
                            <div className="w240 dpFlx aiC">
                                <span className="w60 fm-b fs13 ls06 fc111111">성명</span>
                                <TextBox
                                    value={mbrasNm}
                                    width={180} height={36}
                                    fontSize={14} fontFamily="fm-c" color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd" borderOnColor="#ddd" borderRadius={5}
                                    style={{ backgroundColor: "#F6F6F6", padding: "0 10px" }}
                                    mode="readonly"
                                />
                            </div>

                            <div className="w240 dpFlx aiC">
                                <span className="w60 fm-b fs13 ls06 fc111111">전화번호</span>
                                <TextBox
                                    value={Util.setPhoneNum(telno)}
                                    width={180} height={36}
                                    fontSize={14} fontFamily="fm-c" color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd" borderOnColor="#ddd" borderRadius={5}
                                    style={{ backgroundColor: "#F6F6F6", padding: "0 10px" }}
                                    mode="readonly"
                                />
                            </div>
                        </div>

                        <div className="dpFlx flxNowrap jcSb mt10">
                            <div className="w240 dpFlx aiC">
                                <span className="w60 fm-b fs13 ls06 fc111111">생년월일</span>
                                <DatePickerBox
                                    value={brdtDate}
                                    width={180} height={36}
                                    fontSize={14} fontFamily="fm-c" color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd" borderOnColor="#ddd" borderRadius={5}
                                    bgColor="#F6F6F6" textAlign="left"
                                    calendarThemeColor={AppContext.themeColor}
                                    disabled={true}
                                    onChange={() => {}}
                                />
                            </div>

                            <div className="w240 dpFlx aiC">
                                <span className="w60 fm-b fs13 ls06 fc111111">성별</span>
                                <SelectBox
                                    value={gndrCd}
                                    width={180} height={36}
                                    fontSize={14} fontFamily="fm-c" color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd" borderOnColor="#ddd" borderRadius={5}
                                    background="#F6F6F6" paddingRight={8}
                                    codeArray={Util.getCodeArray("GNDR_CD")}
                                    placeholder=""
                                    disabled={true}
                                />
                            </div>
                        </div>

                        <div className="dpFlx mt10">
                            <div className="w240 dpFlx aiC">
                                <span className="w60 fm-b fs13 ls06 fc111111">
                                    탈퇴<br />
                                    신청일자 <span className="fcE60000">*</span>
                                </span>

                                <DatePickerBox
                                    value={whdwlDt}
                                    width={180} height={36}
                                    fontSize={14} fontFamily="fm-c" color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd" borderOnColor="#222" borderRadius={5}
                                    bgColor="white" textAlign="left"
                                    calendarThemeColor={AppContext.themeColor}
                                    onChange={(data: string) => setWhdwlDt(data)}
                                />
                            </div>
                        </div>

                        <div className="dpFlx aiFs mt10">
                            <span className="w60 fm-b fs13 ls06 fc111111 pt8">
                                탈퇴사유 <span className="fcE60000">*</span>
                            </span>

                            <textarea
                                value={whdwlRsnCn}
                                className="w430 h70 bsBdb p10 bd1 bdcDDDDDD bdrd5 fm-c fs14 fc333333 ls1 bgcWhite rszN"
                                maxLength={2000}
                                placeholder="탈퇴사유를 입력해주세요."
                                onChange={(e) => setWhdwlRsnCn(e.target.value)}
                            />
                        </div>
                    </div>
                </div>

                {/* 변경 내역 */}
                <div className="ml10 mr10 mt20">
                    <div className="fm-b fs16 fc007bff ls1 fw700 mb10">변경 내역</div>

                    <div className="bd1 bdcDDDDDD bdrd10">
                        <div className="dpFlx bdb1 bdcDDDDDD">
                            <div className="w100 h40 dpFlx aiC jcC fm-b fs13 fc111111 bgcFAFAFA bdrdtl10">구분</div>
                            <div className="w210 h40 dpFlx aiC jcC fm-b fs13 fc111111 bdl1 bdcDDDDDD bgcFAFAFA">현재</div>
                            <div className="w210 h40 dpFlx aiC jcC fm-b fs13 fc111111 bdl1 bdcDDDDDD bgcF1F8FF bdrdtr10">변경</div>
                        </div>

                        <div className="dpFlx">
                            <div className="w100 h40 dpFlx aiC jcC fm-c fs14 fc333333 bdrdbl10">상태</div>

                            <div className="w210 h40 dpFlx aiC jcC bdl1 bdcDDDDDD">
                                <SelectBox
                                    value={mbrasJoinSttsCd}
                                    width={170} height={36}
                                    fontSize={14} fontFamily="fm-c" color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd" borderOnColor="#ddd" borderRadius={5}
                                    background="#F6F6F6" paddingRight={8}
                                    codeArray={Util.getCodeArray("MBRAS_JOIN_STTS_CD")}
                                    placeholder=""
                                    disabled={true}
                                />
                            </div>

                            <div className="w210 h40 dpFlx aiC jcC bdl1 bdcDDDDDD bgcF1F8FF bdrdbr10">
                                <SelectBox
                                    value="03"
                                    width={170} height={36}
                                    fontSize={14} fontFamily="fm-c" color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd" borderOnColor="#ddd" borderRadius={5}
                                    background="#F6F6F6" paddingRight={8}
                                    codeArray={Util.getCodeArray("MBRAS_JOIN_STTS_CD")}
                                    placeholder=""
                                    disabled={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* 반려 사유 */}
                {atrzSttsCd === "05" && (
                    <div className="ml10 mr10">
                        <div className="h30 dpFlx aiE pb5 bdBox">
                            <span className="fm-b fs13 ls06 fc111111">반려 사유</span>
                        </div>
                        <textarea
                            value={atrzOpnnCn}
                            className="w520 h60 bsBdb p10 bd1 bdcDDDDDD bdrd4 fm-c fs14 fc333333 ls1 rszN"
                            style={{ backgroundColor: "#f6f6f6" }}
                            maxLength={2000}
                            disabled={true}
                        />
                    </div>
                )}

                {/* 첨부파일 */}
                <div className="mt20 p14 bd1 bdcDDDDDD bdrd10 w520 bgcFAFAFA bsBdb ml10">
                    <div className="fm-c fs16 fc111111 mb10">첨부파일</div>

                    <div className="mb10">
                        <div className="h30 dpFlx aiE pb5 bdBox">
                            <span className="fm-b fs13 ls06 fc111111">탈퇴 신청서</span>
                            <span className="fm-c fs11 fcE60000 ml4">(필수)</span>
                        </div>

                        <div className="mt6">
                            <MemberFile
                                mbrasId={mbrasId}
                                mbrasAtchFileId={whdwlAtchFileId}
                                setMbrasAtchFileId={setWhdwlAtchFileId}
                                mbrFile={whdwlFile}
                                setMbrFile={setWhdwlFile}
                                mbrFileNm={whdwlFileNm}
                                setMbrFileNm={setWhdwlFileNm}
                                atrzSttsCd={atrzSttsCd}
                                mbrasAtrzDocId={mbrasAtrzDocId}
                                setAtrzSttsCd={setAtrzSttsCd}
                                setCallTime={setCallTime}
                            />
                        </div>
                    </div>

                    {wthdStatusCd === "W01" && (
                    <div className="mb10">
                        <div className="h30 dpFlx aiE pb5 bdBox">
                            <span className="fm-b fs13 ls06 fc111111">원천징수 파일</span>
                            <span className="fm-c fs11 fcE60000 ml4">(필수)</span>
                        </div>

                        <div className="mt6">
                            <MemberFile
                                mbrasId={mbrasId}
                                mbrasAtchFileId={wthdAtchFileId}
                                setMbrasAtchFileId={setWthdAtchFileId}
                                mbrFile={wthdFile}
                                setMbrFile={setWthdFile}
                                mbrFileNm={wthdFileNm}
                                setMbrFileNm={setWthdFileNm}
                                atrzSttsCd={atrzSttsCd}
                                mbrasAtrzDocId={mbrasAtrzDocId}
                                setAtrzSttsCd={setAtrzSttsCd}
                                setCallTime={setCallTime}
                            />
                        </div>
                    </div>
                )}

                    <div>
                        <div className="h30 dpFlx aiE pb5 bdBox">
                            <span className="fm-b fs13 ls06 fc111111">기타 첨부파일</span>
                            <span className="fm-c fs11 fc007bff ml4">(필수 아님)</span>
                        </div>

                        <div className="mt6">
                            <MemberFile
                                mbrasId={mbrasId}
                                mbrasAtchFileId={etcAtchFileId}
                                setMbrasAtchFileId={setEtcAtchFileId}
                                mbrFile={etcFile}
                                setMbrFile={setEtcFile}
                                mbrFileNm={etcFileNm}
                                setMbrFileNm={setEtcFileNm}
                                atrzSttsCd={atrzSttsCd}
                                mbrasAtrzDocId={mbrasAtrzDocId}
                                setAtrzSttsCd={setAtrzSttsCd}
                                setCallTime={setCallTime}
                            />
                        </div>
                    </div>
                </div>

                <div className="mt10 taC">
                    <span className="fm-c fs12 fc4A90A4">
                        ※ 임시저장은 입력 중인 내용으로 저장되며, 작성완료는 필수 항목 입력 후 가능합니다.
                    </span>
                </div>

                {/* 버튼 */}
                <div className="dpFlx jcC mt25 gap10 mb10">
                    <Button
                        width={90}
                        height={40}
                        fontFamily="fm-b"
                        fontSize={16}
                        letterSpacing={-1}
                        variant="styCancelBtn"
                        borderRadius={6}
                        buttonClass="dpFlx aiC jcC"
                        buttonName="닫기"
                        onClickFunc={() => setModalOpen(false)}
                    />

                    {Util.isNotEmpty(mbrasAtrzDocId) && (
                        <Button
                            width={90}
                            height={40}
                            fontFamily="fm-b"
                            fontSize={16}
                            letterSpacing={-1}
                            variant="styDeleteBtn"
                            borderRadius={6}
                            buttonClass="dpFlx aiC jcC"
                            buttonName="삭제"
                            onClickFunc={handleDelete}
                        />
                    )}

                    {atrzSttsCd === "01" && (
                        <Button
                            width={110}
                            height={40}
                            fontFamily="fm-b"
                            fontSize={16}
                            letterSpacing={-1}
                            variant="styTempBtn"
                            borderRadius={6}
                            buttonClass="dpFlx aiC jcC"
                            buttonName="임시저장"
                            onClickFunc={() => handleSave("01")}
                        />
                    )}

                    <Button
                        width={110}
                        height={40}
                        fontFamily="fm-b"
                        fontSize={16}
                        letterSpacing={-1}
                        variant="styCompleteBtn"
                        borderRadius={6}
                        buttonClass="dpFlx aiC jcC"
                        buttonName="작성완료"
                        onClickFunc={() => handleSave("02")}
                    />
                </div>
            </div>
        </div>
    );
};

export default MbrasWhdwlApply;